import React from 'react';
import Layout from './Layout';

export default () => (
  <React.StrictMode>
    <Layout />
  </React.StrictMode>
);
